import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const deliveriesDataPush = (vehicle: Vehicle, exportFlag: boolean) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "deliveries",
        action: "navigate",
        type: "",
      },
      ...vehicleDataPush,
      transport: {
        deliveryOption: exportFlag === true ? "export" : "standard",
      },
    });
  }
};

export default deliveriesDataPush;
